<div mat-dialog-content class="flex justify-center items-center p-4">
  <video controls class="w-full h-auto">
    <source [src]="videoUrl" type="video/mp4" />
    Tu navegador no soporta la reproducción de videos.
  </video>
</div>
<div mat-dialog-actions align="end">
  <button mat-button (click)="close()">Cerrar</button>
</div>
